<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<p style="text-indent:0em !important; padding-top:150px;"><strong>Ossining, New York</strong></p>
<p style="text-indent:0em !important;"><strong>6 July 1949</strong></p>
<p style="text-indent:0em !important;"><strong>Colleen</strong></p><br/>
<p><em>“The Girl from Jones Beach” starring Ronald Reagan and Virginia Mayo opens today.</em></p><br/>
<p>In just a few hours, my dear brother Sean will be put in Sing Sing Prison’s electric chair to die. Is it too much to expect a stay of execution or clemency? The idea that my brother might die is too much to bear. I am filled with anger, dread, and my miserable hopefulness. Sean is my protector, my strength, my best friend.</p>
<p>Our story is a sad story; I made my way through the miserableness of my youth by escaping into novels. My love for reading about adventure, mystery and espionage stories gave me the respite I needed to avoid the awfulness and dullness of those early years. Now, I can hold my head up high as the owner of a trendy New York restaurant catering to the city’s hoity-toity. Sean took another path. His life was decidedly more difficult and punishing. He found within himself the brute strength he needed to help us both survive our early years in a less than charitable orphanage. This strength carried him through the mean streets of Hell’s Kitchen and the Westside docks.</p>
<p>Fiercely loyal, he would do anything to protect his family and friends. He learned that a controlled offensive could prove persuasive enough, but he never shied away from overt coercion. Sometimes, a well-aimed fist or gun was all it took. Blessed with a strong dose of common sense, Sean made his way through mobsters, crooked politicians, and coppers on-the-take. Fighting anyone that opposed him provided an irrefutable means to control the ugly of his world.</p>
<p>What he could not control was sensational news stories convicting him in the public eye and an assistant district attorney with political ambitions. He may be guilty just as the ADA of New York says he is, but I know his heart. If he shot that man, it was for good reason; and I’ll be damned, he must have deserved to die!</p><br/>
<p style="text-indent:0em !important;"><strong>Sean</strong></p>
<p style="text-indent:0em !important;"><strong>6 July 1949</strong></p>
<p>They all want me dead. It looks damned good that they will get what they want. All that I wanted to happen is not going to happen. The morning breeze traveling off the Hudson River does nothing to cool me. I’m sweating bullets.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?ca5553e2